export const SIDEBAR_WIDTH = 269;
export const PROPERTIES_BUTTON_WIDTH = 48;

// Left Margin (32px from RowMargin, which has a 8px padding) + Right Margin (Makes room for properties pane buttons)
export const SIDEBAR_MARGIN = 24 + PROPERTIES_BUTTON_WIDTH;

export const PROPERTIES_ICON_SPACER = 2.5 * 16; // 2.5rem x 16px

export const CANVAS_BODY_ID = "CanvasBody";
